module.exports = __webpack_public_path__ + "img/red.673cacf6.png";